
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findFriends"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slotDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkPayment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findFriends"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"bookingTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"slotDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slotDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"checkPayment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkPayment"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"players"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameLong"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hcp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sex_sport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showAvatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confirmed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payGreenfee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forceGreenfeePayment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasAbo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"playerGroups"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"players"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameLong"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sex_sport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showAvatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarLink"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"friendsNotConfirmed"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameLong"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sex_sport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showAvatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confirmed"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"friendsDeclined"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameLong"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sex_sport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showAvatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confirmed"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":868}};
    doc.loc.source = {"body":"query findFriends($bookingTypeId: String, $slotDate: String, $checkPayment: Boolean )  {\n  findFriends(input: {\n    bookingTypeId: $bookingTypeId, slotDate: $slotDate, checkPayment: $checkPayment\n  }) {\n    players {\n      nameLong\n      lastName,\n      firstName,\n      hcp,\n      id,\n      sex_sport,\n      showAvatar,\n      avatarLink,\n      confirmed,\n      price\n      payGreenfee,\n      forceGreenfeePayment,\n      hasAbo\n    },\n    playerGroups {\n      id,\n      name,\n      showContent,\n      players {\n        nameLong\n        id,\n        sex_sport,\n        showAvatar,\n        avatarLink\n      }\n    },\n    friendsNotConfirmed {\n      nameLong\n      id,\n      sex_sport,\n      showAvatar,\n      avatarLink,\n      confirmed,\n    }\n    friendsDeclined {\n      nameLong\n      id,\n      sex_sport,\n      showAvatar,\n      avatarLink,\n      confirmed,\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["findFriends"] = oneQuery(doc, "findFriends");
        
